import TrustForm from './TrustForm'

export default TrustForm
